import React, { Component } from "react";
import { Button, Modal, Icon } from "antd";

export default class SignupModal extends Component {
  state = { googleHover: false, modal: this.props.modal };

  handleGoogleHover = () => {
    this.setState({ googleHover: true });
  };

  handleGoogleStopHover = () => {
    this.setState({ googleHover: false });
  };

  render() {
    return (
      <div>
        <span onClick={e => this.setState({ modal: true })}>Login</span>

        <Modal
          footer={null}
          closeIcon
          onCancel={e => {
            this.setState({ modal: false });
            if (this.props.noButton) this.props.onClose();
          }}
          visible={this.state.modal}
        >
          <a href="/auth/google">
            <img
              alt="Sign up with Google"
              src={`../images/google/btn_google_signin_light_${
                this.state.googleHover ? "focus_web.png" : "normal_web.png"
              }`}
              onMouseEnter={this.handleGoogleHover}
              onMouseLeave={this.handleGoogleStopHover}
            />
          </a>
          <a href="/auth/facebook">
            <Button compact style={{ height: 46, color: "#3B5998" }}>
              {" "}
              <Icon size="large" name="facebook" />
              Continue with Facebook
            </Button>
          </a>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/account/SignupModal.js